import Cos from './cos/cos';

export default {
  install(Vue) {
    Vue.prototype.$cos = Cos;
  },
};
